export default __webpack_public_path__ + "static/media/course_cart.66fe20ff.svg";